import {APIClient} from "../../api/httpClient";

import * as url from "./endpoints";


const api = new APIClient();

// Pages > Team
export const getTeamData = () => api.get(url.GET_TEAMDATA);
export const deleteTeamData = (team: any) =>
    api.delete(url.DELETE_TEAMDATA, {headers: {team}});
export const addTeamData = (team: any) =>
    api.create(url.ADD_NEW_TEAMDATA, team);
export const updateTeamData = (team: any) => api.put(url.UPDATE_TEAMDATA, team);
